var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.name}},[_c('router-view'),_c('notifications',{attrs:{"group":"formGroup","position":"bottom right"}}),_c('Loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }